import React from "react";
import NnPianoApp from "./NnPianoApp";
import { Redirect, Route, Switch } from "react-router-dom";
import SongManager from "./music/SongManager";
import * as qs from 'query-string';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Switch>
        <Route
          exact path="/"
          render={()=> <Redirect to="/song/ode-to-joy?skin=tech"/>}
        />
        <Route
          path="/song/:songId"
          render={({location, match}) => {
            const {skin,timing,letters} = qs.parse(location.search);
            const songId = match.params.songId;
            return <NnPianoApp
              songId={songId}
              songs={this.state.songs}
              skin={skin}
              timing={typeof timing !== 'undefined'}
              letters={typeof letters !== 'undefined'}
              />
          }}
        />
      </Switch>
    );
  }

  componentDidMount() {
    SongManager
      .loadSongIndex("/songs/index.json")
      .then(index => this.setState({songs: index.songs}))
  }
}
export default App;
